import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';

import { Navigate } from 'react-router-dom';

const NotFoundRedirect = () => {
  const { isAuthenticated } = useAuth0();

  if (isAuthenticated) {
    return <Navigate to="/errors/internal404" replace />;
  } else {
    return <Navigate to="/errors/404" replace />;
  }
};

export default NotFoundRedirect;
